import { createFileRoute } from "@tanstack/react-router";
import AboutPage from "@project/user/pages/about/index";

export const Route = createFileRoute("/_user/about")({
  head: () => ({
    meta: [
      { title: "About Jivandhara — A Home Where Every Elder Belongs" },
      {
        name: "description",
        content:
          "25 years of seva. Discover Jivandhara Trust's journey, founders, milestones, values and the family-style elder care we deliver every day.",
      },
      {
        property: "og:title",
        content: "About Jivandhara — A Home Where Every Elder Belongs",
      },
      {
        property: "og:description",
        content:
          "Our story, mission, milestones and the people behind Jivandhara's lifetime care for elders.",
      },
      { property: "og:image", content: careImg },
      { name: "twitter:image", content: careImg },
    ],
  }),
  component: AboutPage,
});
